import React, { Component } from 'react'

//const Image = styled.img`
//  display: block;
//  max-width: 100%;
//  transition: 175ms ease-in-out;
//`

export default class ImageShift extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mounted: false,
    }
  }
  componentDidMount() {
    this.setState({
      mounted: true
    })
  }

  render() {
    const { src, alt, mounted, color, className } = this.props;
	var classT = className;
	if(mounted){
		classT = "image-loading";
	}
	if(color){
		classT = classT + " background-color-" + color;
	}
	//<img src={src} className={ mounted &&
    //        "image-loading"} />
    return (
		<img src={src} className={classT} alt={alt}/>
	)
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageShift.js